import { homeURL } from '../../../utils/constants'
import errorConstants from '../../errorConstants'
import { MessageFormat } from '@paypalcorp/worldready'
import fpti from '../../../instrumentation'

const errorHandler = (
  e,
  errorSetter,
  worldReady,
  btnState = null,
  setLoading = null,
) => {
  if (
    e.message === null ||
    errorConstants[e.message] === undefined ||
    errorConstants[e.message] === errorConstants.SOMETHING_WENT_WRONG
  ) {
    const message = `${new MessageFormat(worldReady, {
      id: `thirdPartyPerm.${errorConstants.SOMETHING_WENT_WRONG}`,
    }).format()}\n${e.error.error_code}:${e.error.error_message}`
    errorSetter(message)
    fpti.logFPTIError(
      e,
      errorConstants.SOMETHING_WENT_WRONG,
      errorConstants.SOMETHING_WENT_WRONG,
    )
    if (btnState !== null) {
      btnState('initial')
    }
    if (setLoading !== null) {
      setLoading(false)
    }
  } else if (
    errorConstants[e.message] === errorConstants.SECURITY_CONTEXT_NULL
  ) {
    fpti.logFPTIError(
      e,
      'User not logged in',
      errorConstants.SECURITY_CONTEXT_NULL,
    )
    window.location.href = e.failureRedirect
  } else if (errorConstants[e.message] === errorConstants.NOT_AUTHORIZED) {
    fpti.logFPTIError(e, 'User not authorized', errorConstants.NOT_AUTHORIZED)
    window.location.href = homeURL
  } else {
    errorSetter(
      new MessageFormat(worldReady, {
        id: `thirdPartyPerm.${errorConstants[e.message]}`,
      }).format(),
    )
    fpti.logFPTIError(e, 'Application error', errorConstants[e.message])
    if (btnState !== null) {
      btnState('initial')
    }
    if (setLoading !== null) {
      setLoading(false)
    }
  }
}

export default errorHandler
